import { useEffect } from 'react';
import { useAvailableItemConfigContext } from './useContext/useAvailableItemConfigContext';

const useFetchOpenStatus = () => {
  const { dispatch } = useAvailableItemConfigContext();

  useEffect(() => {
    const fetchOpenStatus = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/user/getOpenStatus");
        const json = await response.json();
        if (response.ok) {
          dispatch({ type: "SET_OPEN_STATUS", payload: json });
          // console.log('open status:', json);
        } else {
          console.error('Error fetching open status:', json);
        }
      } catch (error) {
        console.error('Network error when fetching open status:', error);
      }
    };

    fetchOpenStatus();
  }, [dispatch]);

  return null;
};

export default useFetchOpenStatus;